export default __webpack_public_path__ + "static/media/Conscript's Vambraces of the Battlements.3d52c21f.jpg";